{
    "warning": "WAARSCHUWING!",
    "message": "Voer geen code in en plak geen code die je niet begrijpt.\nMet deze console kunnen aanvallers zich mogelijk als jou voordoen en gegevens stelen via een aanval die Self-XSS heet."
}
